import { IconContentTrash } from '@doltech/icons/IconContentTrash';
import { Space } from 'antd';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '../../colors-v2';
import { LineDivider } from '../../Divider/LineDivider';
import { DeleteElementButtonProps } from './DeleteElementButton';

interface Action extends React.HTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
}

interface DeleteElementButtonAndActionsProps extends DeleteElementButtonProps {
  visible: boolean;
  actions?: Action[];
}

export const DeleteElementButtonAndActions = (props: DeleteElementButtonAndActionsProps) => {
  const { className, visible, actions = [], ...del } = props;
  const ref = React.useRef<HTMLDivElement | undefined>();

  return (
    <Container
      ref={ref}
      containerWidth={ref.current?.offsetWidth}
      contentEditable={false}
      className={cl(className, 'delete-button-with-actions', { visible })}
    >
      <Space
        size={0}
        split={<LineDivider directional="vertical" style={{ height: 32 }} space={0} />}
      >
        <Space>
          {actions.map(({ icon, ...btn }, idx) => (
            <Button type="button" key={idx} {...btn}>
              {icon}
            </Button>
          ))}
        </Space>
        <Button type="button" {...del}>
          <IconContentTrash />
        </Button>
      </Space>
    </Container>
  );
};

const DELETE_BUTTON_SIZE = 48;

const Container = styled.div<any>`
  position: absolute;
  bottom: -${DELETE_BUTTON_SIZE + 8}px;
  left: calc(50% - ${(p) => p.containerWidth / 2}px);
  background-color: ${colorsV2.white100};
  border: 1px solid ${colorsV2.black10};
  box-shadow: 0 16px 24px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.04),
    0 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  transition: all 0.2s ease;
  overflow: hidden;

  opacity: 0;
  pointer-events: none;
  z-index: -1;
  transform: translateY(${DELETE_BUTTON_SIZE / 2}px);

  &.visible {
    opacity: 1;
    pointer-events: auto;
    z-index: 10;
    transform: translateY(0);
  }
`;

const Button = styled.button`
  border: none;
  outline: none;
  width: ${DELETE_BUTTON_SIZE}px;
  height: ${DELETE_BUTTON_SIZE}px;
  min-width: ${DELETE_BUTTON_SIZE}px;
  min-height: ${DELETE_BUTTON_SIZE}px;
  cursor: pointer;
  display: inline-grid;
  place-items: center;
  font-size: 24px;
  color: ${colorsV2.black100};
  background: ${colorsV2.white100};
  line-height: 0;
  transition: all 0.2s ease;

  &:hover {
    filter: brightness(90%);
  }
  &:active {
    transform: scale(0.96);
  }
`;
